import { Navigate } from "react-router-dom";
import { UserAuth } from "../context/AuthContext";

import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://c4c8289ee9edd85e26ed5db9ba691ec0@o4510544169271296.ingest.us.sentry.io/4510544171827200",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  integrations: [
    Sentry.feedbackIntegration({
      colorScheme: "system",
      // autoInject: false
      formTitle: "Leave Feedback",
      triggerLabel: "Leave Feedback"
    }),
  ]
});

const ProtectedRoute = ({ children }) => {
  const { user, authLoading } = UserAuth();

  if (authLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/" />;
  }

  Sentry.setUser({
    email: user.email,
  });

  return children;
};
export default ProtectedRoute;
